import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { USER_ROLES } from '@pwc/pwc-deals-web-common';
import { useSelector } from 'react-redux';
import { getUserRole } from 'common/redux/security/loggedInUser/loggedInUserSlice';

import featureFlags from 'common/helpers/featureFlags';
import ProjectOverview from './ProjectOverview';
import ProjectOverviewReportPreview from './ProjectOverview/ProjectOverviewReportPreview';

const ProjectOverviewContentRouter = () => {
  const isPwcUser = useSelector(getUserRole) === USER_ROLES.PWC_USER;
  return (
    <>
      <Switch>
        <Route
          exact
          path="/projects/:projectId"
          render={(props) => {
            // we should redirect outside of the junction links to the po refactoring.
            if (featureFlags.isPOTopicRefactorEnabled) {
              return (
                <Redirect
                  to={`/projects/${props.match.params.projectId}/topics/${
                    isPwcUser ? 'draft' : 'shared'
                  }`}
                />
              );
            }
            return (
              <ProjectOverview
                {...props}
                key={
                  featureFlags.isAutoSaveEnabled
                    ? props.location.key
                    : undefined
                }
              />
            );
          }}
        />
        <Route
          exact
          path="/projects/:projectId/topics/:contentThreadId/report-preview/:versionStatus/:version"
          component={ProjectOverviewReportPreview}
        />
      </Switch>
    </>
  );
};

export default ProjectOverviewContentRouter;
